<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : project.pkId ? '编辑' : '新建'"
      width="850px"
      class="projectEdit"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="project"
        :rules="ruleValidate"
        class="form"
        label-width="110px">
      <div class="editTitle">项目信息</div>
      <el-row>
        <el-col v-if="project.pkId" :span="12">
          <el-form-item label="项目编号" prop="projectNo">
            <el-input v-model="project.projectNo" placeholder="请输入项目编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="project.projectName" placeholder="请输入项目名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="访问控制" prop="accessControl">
            <el-select v-model="project.accessControl" placeholder="请选择访问控制">
              <el-option label="公开" :value="0"/>
              <el-option label="仅项目成员" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划开始日期" prop="planBeginDate">
            <el-date-picker
                v-model="project.planBeginDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                type="date"
                placeholder="请选择计划开始日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划完成日期" prop="planEndDate">
            <el-date-picker
                v-model="project.planEndDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                type="date"
                placeholder="请选择计划完成日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目负责人" prop="projectManagerName">
            <el-input v-model="project.projectManagerName" placeholder="请选择项目负责人" readonly>
              <el-button slot="append" @click="$refs.selectManager.open()">选择</el-button>
            </el-input>
            <employee-select ref="selectManager" @select="onSelectManager"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目描述" prop="projectDesc">
            <el-input v-model="project.projectDesc" type="textarea" autosize placeholder="请输入项目描述"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">团队成员</div>
      <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMember.open()"> 添加 </el-button>
      <el-table border :data="project.memberList">
        <el-table-column prop="memberName" align="left" label="姓名"/>
        <el-table-column label="操作" align="center" prop="action" width="80">
          <template slot-scope="scope">
            <el-button type="danger" @click="project.memberList.splice(scope.$index, 1)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <selectMember ref="selectMember" @select="onSelectMember"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import EmployeeSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import selectMember from "@/views/SystemInfo/SystemUser/UserSelect";
  export default {
    name: "ProjectEdit",
    components: { EmployeeSelect, selectMember },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: "",
        project: {
          pkId: 0,
          projectNo: "",
          projectName: "",
          accessControl: "",
          planBeginDate: "",
          planEndDate: "",
          projectDesc: "",
          projectManagerId: "",
          projectManagerName: "",
          memberList: [],
        },
        ruleValidate: {
          projectNo: { required: true, message: "请输入项目编号", trigger: "blur" },
          projectName: { required: true, message: "请输入项目名称", trigger: "blur" },
          accessControl: { required: true, message: "请选择访问控制", trigger: "blur" },
          planBeginDate: { required: true, message: "请选择计划开始日期", trigger: "blur" },
          planEndDate: { required: true, message: "请选择计划完成日期", trigger: "blur" },
          projectDesc: { required: true, message: "请输入项目描述", trigger: "blur" },
          projectManagerName: { required: true, message: "请选择项目负责人", trigger: "blur" },
        },
      };
    },

    methods: {
      open(row, disabled) {
        this.disabled = disabled;
        this.dialogVisible = true;
        if (row) {
          this.project.pkId = row.pkId;
          this.getData();
        }
      },

      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `projects/${this.project.pkId}`)
          .then((resp) => {
            this.contentLoading = false;
            if (resp.success) {
              this.project = Object.assign(this.project, resp.data);
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      onSelectManager(row) {
        this.project.projectManagerId = row.systemUserID;
        this.project.projectManagerName = row.employeeName;
      },

      onSelectMember(row) {
        console.log(row);
        const arr = this.project.memberList.filter((item) => item.memberId === row.employeeID);
        if (arr.length) {
          this.$confirm(`${row.employeeName}已存在,请勿重复添加`, "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const member = {
          memberId: row.systemUserID,
          memberName: row.employeeName,
        };
        this.project.memberList.push(member);
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.project.memberList.length === 0) {
              this.$confirm("团队成员不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              this.submitLoading = true;
              this.$http
                .save("basic", "projects", this.project)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    if (this.project.pkId) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                    this.dialogVisible = false;
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style>
.projectEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.projectEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.projectEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.projectEdit .el-divider--horizontal {
  margin: 10px 0;
}

.projectEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>
